<template>
  <v-data-table
    v-if="calculos.length > 0"
    :headers="headers"
    :items="calculos"
    :items-per-page="5"
    class="elevation-1"
    :footer-props="{
      itemsPerPageAllText: 'Todos',
      itemsPerPageText: 'Cálculos por página'
    }"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Cálculos</v-toolbar-title>
        <v-spacer></v-spacer>
        <download-excel
          :data="calculos"
          name="sindecPassivoServidores.xls"
          :export-fields="camposExportar"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mx-2" fab dark x-small v-bind="attrs" v-on="on" color="green">
                <v-icon dark>mdi-file-excel-box</v-icon>
              </v-btn>
            </template>
            <span>Exportar cálculos para arquivo .xls</span>
          </v-tooltip>
        </download-excel>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-2"
              fab
              dark
              x-small
              v-bind="attrs"
              v-on="on"
              color="red"
              @click="exportarCalculosPDF()"
            >
              <v-icon dark>mdi-file-pdf-box</v-icon>
            </v-btn>
          </template>
          <span>Exportar cálculos para arquivo .pdf</span>
        </v-tooltip>
      </v-toolbar>
    </template>
    <template v-slot:item.acoes="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mx-2"
            fab
            dark
            x-small
            v-bind="attrs"
            v-on="on"
            color="blue"
            @click="exportarMemoriaCalculoPDF(item)"
          >
            <v-icon dark>mdi-calculator</v-icon>
          </v-btn>
        </template>
        <span>Exportar memória de cálculo.</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mx-2"
            fab
            dark
            x-small
            v-bind="attrs"
            v-on="on"
            color="red"
            @click="deletarCalculo(item)"
          >
            <v-icon dark>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Excluir cálculo da lista.</span>
      </v-tooltip>
    </template>
    <template v-slot:footer.page-text="props">
      {{ props.pageStart }}-{{ props.pageStop }} de
      {{ props.itemsLength }}
    </template>
  </v-data-table>
</template>

<script>
import { mapActions } from "vuex";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  data() {
    return {
      headers: [
        {
          text: "Data Original",
          align: "start",
          sortable: false,
          value: "dataValorOriginal"
        },
        { text: "Valor Original	", value: "valorOriginal" },
        { text: "Descrição", value: "descricao" },
        {
          text: "Data Incid. Juros",
          value: "dataJuros"
        },
        { text: "Data Atualização", value: "dataAtualizacao" },
        {
          text: "Atualização Monetária",
          value: "correcaoMonetaria"
        },
        {
          text: "Fator de Atualização",
          value: "correcaoMonetariaPercentual"
        },
        {
          text: "Juros",
          value: "juros"
        },
        {
          text: "Juros %",
          value: "jurosPercentual"
        },

        { text: "Valor Corrigido", value: "valorCorrigido" },
        { text: "Ações", value: "acoes", sortable: false }
      ],
      camposExportar: {
        "Data do Valor Original": "dataValorOriginal",
        "Valor Original": "valorOriginal",
        Descrição: "descricao",
        "Data de Incidência de Juros": "dataJuros",
        "Data de Atualização": "dataAtualizacao",
        "Atualização Monetária": "correcaoMonetaria",
        "Fator de Atualização": "correcaoMonetariaPercentual",
        Juros: "juros",
        "Juros %": "jurosPercentual",
        "Valor Corrigido": "valorCorrigido"
      }
    };
  },
  computed: {
    calculos: function() {
      return this.$store.state.calculos;
    }
  },
  methods: {
    ...mapActions(["removeCalculo"]),
    deletarCalculo(item) {
      let indice = this.calculos.indexOf(item);
      this.removeCalculo(indice);
    },
    exportarCalculosPDF() {
      let calculosOrdenados = Array();
      this.calculos.forEach(calculo => {
        calculosOrdenados.push([
          calculo.dataValorOriginal,
          calculo.valorOriginal,
          calculo.descricao,
          calculo.dataJuros,
          calculo.dataAtualizacao,
          calculo.correcaoMonetaria,
          calculo.correcaoMonetariaPercentual,
          calculo.juros,
          calculo.jurosPercentual,
          calculo.valorCorrigido
        ]);
      });
      let valoresCalculos = calculosOrdenados.map(elemento =>
        Object.values(elemento)
      );

      let reducerSomatorios = (accumulator, currentValue) => {
        for (let index = 5; index < 10; index += 2) {
          if (currentValue[index]) {
            accumulator[index] += parseFloat(
              currentValue[index]
                .substring(3)
                .replace(/\./g, "")
                .replace(/,/g, ".")
            );
          }
        }
        accumulator[1] += parseFloat(
          currentValue[1]
            .substring(3)
            .replace(/\./g, "")
            .replace(/,/g, ".")
        );
        return accumulator;
      };

      let somaValoresCorrigidos = valoresCalculos.reduce(reducerSomatorios, [
        "TOTAL",
        0,
        "",
        "",
        "",
        0,
        "",
        0,
        "",
        0
      ]);

      let formatadorMoeda = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        maximumFractionDigits: 2
      });

      for (let index = 5; index < 10; index += 2) {
        if(somaValoresCorrigidos[index]) {
          somaValoresCorrigidos[index] = formatadorMoeda.format(
            somaValoresCorrigidos[index]
          );
        }
      }
      somaValoresCorrigidos[1] = formatadorMoeda.format(
        somaValoresCorrigidos[1]
      );


      valoresCalculos.push(somaValoresCorrigidos);

      let hoje = new Date();
      var dataHoje =
        hoje.getDate() + "/" + (hoje.getMonth() + 1) + "/" + hoje.getFullYear();
      var horaHoje =
        hoje.getHours() + ":" + hoje.getMinutes() + ":" + hoje.getSeconds();

      let pdf = new jsPDF({
        orientation: "landscape"
      });
      pdf.autoTable({
        head: [
          [
            "Data Original",
            "Valor Original",
            "Descrição",
            "Data Juros",
            "Data C. M.",
            "C.M.",
            "C.M. %",
            "Juros",
            "Juros %",
            "Valor Corrigido"
          ]
        ],
        body: valoresCalculos,
        didDrawPage: function(data) {
          // Header
          pdf.setFontSize(18);
          pdf.setTextColor(40);
          pdf.setFontStyle("normal");
          pdf.text(
            "TCDF - SINDEC - Passivo a Servidores. Exportação realizada em " +
              dataHoje +
              " às " +
              horaHoje,
            data.settings.margin.left,
            22
          );

          // Footer
          var str = "Página " + pdf.internal.getNumberOfPages();
          pdf.setFontSize(10);

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = pdf.internal.pageSize;
          var pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
          pdf.text(str, data.settings.margin.left, pageHeight - 10);
        },
        willDrawCell: function(data) {
          var rows = data.table.body;
          if (data.row.index === rows.length - 1) {
            pdf.setFillColor(0, 130, 183);
            pdf.setTextColor(255, 255, 255);
          }
          pdf.setFontSize(8);
        },
        margin: { top: 30 }
      });
      pdf.addPage();
      pdf.autoTable({
          head: [
            [
              "Período",
              "Correção Monetária",
              "Juros Mensais"
            ]
          ],
          body: [
            ['até 31/08/2001', 'INPC', '1,0%'],
            ['01/09/2001 a 29/06/2009', 'INPC', '0,5%'],
            ['a partir de 30/06/2009', 'IPCA-15', 'juros da poupança']
          ],
          columnStyles: {
            0: {fillColor: [41, 128, 185], textColor: 255, halign: 'center'}
          },
          headStyles: {
            halign: 'center'
          },
          margin: { top: 30 },
          didDrawPage: function(data) {
            // Header
            pdf.setFontSize(18);
            pdf.setTextColor(40);
            pdf.setFontStyle("normal");
            pdf.text(
              "TCDF - SINDEC - Passivo a Servidores. Metodologia de Cálculo.",
              data.settings.margin.left,
              22
            );

            // Footer
            var str = "Página " + pdf.internal.getNumberOfPages();
            pdf.setFontSize(10);

            // jsPDF 1.4+ uses getWidth, <1.4 uses .width
            var pageSize = pdf.internal.pageSize;
            var pageHeight = pageSize.height
              ? pageSize.height
              : pageSize.getHeight();
            pdf.text(str, data.settings.margin.left, pageHeight - 10);
          }
      });
      pdf.save("sindecPassivoServidores.pdf");
    },
    exportarMemoriaCalculoPDF(item) {
      let memoriaCalculoFormatada = [];

      for (let i = 0; i < item.memoriaCalculo.length; i++) {
        let detalhe = item.memoriaCalculo[i];
        let texto = detalhe.texto;
        let valores = detalhe.valores;
        let indice = detalhe.indice;

        let detalheFormatado = [
          texto,
          valores.valorAntes ? `R$ ${valores.valorAntes.toFixed(2)}` : "",
          valores.valorDepois ? `R$ ${valores.valorDepois.toFixed(2)}` : "",
          valores.correcaoMonetaria ? `R$ ${valores.correcaoMonetaria.toFixed(2)}` : "",
          valores.juros ? `R$ ${valores.juros.toFixed(2)}` : "",
          valores.valorAtualizado ? `R$ ${valores.valorAtualizado.toFixed(2)}` : "",
          indice
        ];

        memoriaCalculoFormatada.push(detalheFormatado);
      }

      let hoje = new Date();
      var dataHoje =
        hoje.getDate() + "/" + (hoje.getMonth() + 1) + "/" + hoje.getFullYear();
      var horaHoje =
        hoje.getHours() + ":" + hoje.getMinutes() + ":" + hoje.getSeconds();

      let doc = new jsPDF({
        orientation: "landscape",
      });

      // Adicionar texto "Memória de Cálculo..." acima do cabeçalho
      doc.setFontSize(18);
      doc.setTextColor(40);
      doc.setFontStyle("normal");
      doc.text(
        "Memória de Cálculo - SINDEC. Exportação realizada em " +
          dataHoje +
          " às " +
          horaHoje,
        30,
        10
      );

      // Adicionar campos de cabeçalho
      doc.setFontSize(10);
      doc.setTextColor(40);

      let headerPositionX = 10;
      let headerPositionY = 25;
      let headerSpacing = 80;

      if (item.descricao) {
        doc.text("Descrição do Cálculo:", headerPositionX, headerPositionY);
        doc.text(item.descricao, headerPositionX, headerPositionY + 5);
        headerPositionX += headerSpacing;
      }

      doc.text("Data do Valor Original:", headerPositionX, headerPositionY);
      doc.text(item.dataValorOriginal, headerPositionX, headerPositionY + 5);
      headerPositionX += headerSpacing;

      doc.text("Valor Original:", headerPositionX, headerPositionY);
      doc.text(item.valorOriginal, headerPositionX, headerPositionY + 5);
      headerPositionX = 10;
      headerPositionY += 20;

      if (item.dataJuros) {
        doc.text("Data de Início de Juros:", headerPositionX, headerPositionY);
        doc.text(item.dataJuros, headerPositionX, headerPositionY + 5);
        headerPositionX += headerSpacing;
      }

      doc.text("Data de Atualização:", headerPositionX, headerPositionY);
      doc.text(item.dataAtualizacao, headerPositionX, headerPositionY + 5);


      doc.autoTable({
        head: [
          ["Texto", "Valor Antes", "Valor Depois", "Correção Monetária", "Juros", "Valor Atualizado", "Índice",],
        ],
        body: memoriaCalculoFormatada,
        didDrawPage: function (data) {
          var str = "Página " + doc.internal.getNumberOfPages();
          doc.setFontSize(10);

          var pageSize = doc.internal.pageSize;
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
          doc.text(str, data.settings.margin.left, pageHeight - 10);
        },
        margin: { top: 60 },
      });

      doc.save("memoriaCalculo.pdf");
    }
  }
};
</script>

<style lang="scss" scoped></style>
